'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * 记录promise的action，验证loading
 * @type {{}}
 */
var loadingMap = {};

var startLoadingMiddleware = exports.startLoadingMiddleware = function startLoadingMiddleware() {
  return function (next) {
    return function (action) {
      if (action.promise) {
        next({
          type: 'loading/start',
          data: action.type
        });
        loadingMap[action.type] = true;
        return next(action);
      } else {
        return next(action);
      }
    };
  };
};

var endLoadingMiddleware = exports.endLoadingMiddleware = function endLoadingMiddleware() {
  return function (next) {
    return function (action) {
      if (loadingMap[action.type]) {
        loadingMap[action.type] = false;
        next({
          type: 'loading/end',
          data: action.type
        });
      }
      return next(action);
    };
  };
};